import { connect } from "react-redux";

import { FullFormState } from "../../../../Engine/Core/Store/FullFormState";
import { withViewModelSelect } from "../../../withViewModelSelect";
import { ViewModelSelect } from "../../../../Helpers/StateAccessors/ViewModelSelect";
import { CandyDispatch } from "../../../../Engine/Core/Store/CandyReduxTypes";
import { CustomFile } from "../../../../Helpers/file";
import { UploadFormTypes } from "../../../../Engine/Externals/FufManager/IFufManager";
import {
    reloadForm,
    reloadFormInner,
    setFufAction,
    UploadedFileInfo,
    uploadFufFileAction,
} from "../../../../Engine/ActionCreators/FufUploadActionCreator";
import { FileProps } from "../../../../Engine/Core/ModalManager/Modals/Utils/Types";
import { addBulkFilesAction, loadAttachmentAsFile } from "../../../../Engine/ActionCreators/AttachmentActionCreators";
import {
    AbsoluteModelPath,
    AbsoluteResolvedModelPath,
    createAbsoluteResolvedFromTokens,
} from "../../../../../../Common/ModelPath/ModelPath";
import { BulkFiles } from "../../../../Engine/Externals/Attachments/IAttachmentsManager";

import { AttachmentNames, UnitItem } from "./FufAndAttachmentsUploadModalTypes";
import { FilePropertiesOptions, FufAndAttachmentsUploadModal } from "./FufAndAttachmentsUploadModal";

interface FufAndAttachmentsUploadModalContainer {
    viewModelSelect: ViewModelSelect;
    attachmentNames: AttachmentNames;
}

const mapStateToProps = (state: FullFormState, ownProps: FufAndAttachmentsUploadModalContainer) => ({
    currentGfv: state.settings.gfv,
    isFormInFormNds: state.settings.isFormInFormNds ?? false,
    attachmentNames: {
        ...ownProps.attachmentNames,
        [state.settings.gfv]: {
            name: "Разделы 1-7",
            index: -1,
        },
    },
    useServerSideFLangNormalization: state.settings.useServerSideFLangNormalization,
    getNextAttachmentBindingPath: (bindingPath: AbsoluteModelPath): AbsoluteResolvedModelPath => {
        const nextIndex = ownProps.viewModelSelect.pathViewModel(state, bindingPath)?.children?.length ?? 0;

        return createAbsoluteResolvedFromTokens(
            bindingPath.joinWith(nextIndex.toString()).getSimpleTokensAsArrayStrict()
        );
    },
});

const mapDispatchToProps = (dispatch: CandyDispatch) => ({
    getFileProperties: (file: CustomFile, options: FilePropertiesOptions): Promise<UploadedFileInfo> =>
        dispatch(
            uploadFufFileAction(file, true, true, {
                formType: options.isFormInFormNds ? UploadFormTypes.NDS : UploadFormTypes.default,
                declarationGfv: options.declarationGfv,
            })
        ),
    setFuf: (driveUri: string): Promise<void> => dispatch(setFufAction(driveUri)),
    onLoadAttachmentFile: (attachmentUnit: UnitItem, gfv: string, bindingPath: AbsoluteResolvedModelPath) => {
        const loadedFileProps: FileProps = {
            uploadFile: attachmentUnit.file,
            ndsTotalSum: attachmentUnit.file.ndsTotalSum?.toString(),
        };

        return dispatch(loadAttachmentAsFile(loadedFileProps, gfv, bindingPath));
    },
    reloadForm: async (useServerSideFLangNormalization?: boolean): Promise<void> => {
        if (useServerSideFLangNormalization) {
            await dispatch(reloadFormInner());
        } else {
            reloadForm();
        }
    },
    addBulkAttachments: (bulkFiles: BulkFiles[]) => dispatch(addBulkFilesAction(bulkFiles)),
});

export const FufAndAttachmentsUploadModalContainer = withViewModelSelect(
    connect(mapStateToProps, mapDispatchToProps)(FufAndAttachmentsUploadModal)
);
